import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import LineChart from "../../components/LineChart";
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { showError } from "../../constants";
import {
  useLazyGetEarningGraphQuery,
  useLazyGetUserGraphQuery,
} from "../../services/main";
import useTranslation from "../../hooks/Translation";

const Analytics = () => {
  const [getUserGraphQuery] = useLazyGetUserGraphQuery();
  const [getEarningGraphQuery] = useLazyGetEarningGraphQuery();
  const [userFilter, setUserFilter] = useState<string>("monthly");
  const [earningFilter, setEarningFilter] = useState<string>("monthly");
  const [userGraph, setUserGraph] = useState<any>([]);
  const [earningGraph, setEarningGraph] = useState<any>([]);
  const translate = useTranslation();

  const getUserGraph = async () => {
    try {
      const response = await getUserGraphQuery({
        type: userFilter,
      }).unwrap();
      if (response?.statusCode === 200) {
        setUserGraph(response?.data?.userCount);
      } else {
        setUserGraph([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getEarningGraph = async () => {
    try {
      const response = await getEarningGraphQuery({
        type: earningFilter,
      }).unwrap();
      if (response?.statusCode === 200) {
        setEarningGraph(response?.data?.earningCount);
      } else {
        setEarningGraph([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleOrderChange = (event: SelectChangeEvent) => {
    setUserFilter(event.target.value as string);
  };

  const handleEarningChange = (event: SelectChangeEvent) => {
    setEarningFilter(event.target.value as string);
  };

  const names = userGraph?.map((item: any) => item._id);
  const values = userGraph?.map((item: any) => item.count);

  const rNames = earningGraph?.map((item: any) => item._id);
  const rValues = earningGraph?.map((item: any) => item.count);

  const graphUsersData = {
    labels: names,
    datasets: [
      {
        label: translate?.dashboard?.User,
        data: values,
        borderColor: "#151D30",
        backgroundColor: "#151D30",
      },
    ],
  };

  const graphRevenueData = {
    labels: rNames,
    datasets: [
      {
        label: translate?.dashboard?.Earning,
        data: rValues,
        borderColor: "#151D30",
        backgroundColor: "#151D30",
      },
    ],
  };

  useEffect(() => {
    getUserGraph();
  }, [userFilter]);

  useEffect(() => {
    getEarningGraph();
  }, [earningFilter]);

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{translate?.main?.ReportsandAnalytics}</h1>
        </div>
        <Grid container spacing={2} className="dashGraph">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className="cards dashGraph_item">
              <h2 className="mn_hdng">
               {translate?.main?.TotalUsers}
                <FormControl>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={userFilter}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    onChange={handleOrderChange}
                  >
                    <MenuItem value="" disabled>
                    {translate?.dashboard?.Select}
                    </MenuItem>
                    <MenuItem value="hourly"> {translate?.dashboard?.Hourly}</MenuItem>
                    <MenuItem value="weekly"> {translate?.dashboard?.Weekly}</MenuItem>
                    <MenuItem value="monthly"> {translate?.dashboard?.Monthly}</MenuItem>
                    <MenuItem value="yearly"> {translate?.dashboard?.Yearly}</MenuItem>
                  </Select>
                </FormControl>
              </h2>
              <LineChart data={graphUsersData} />
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className="cards dashGraph_item">
              <h2 className="mn_hdng">
               {translate?.main?.TotalEarnings}
                <FormControl>
                  <Select
                    className="select_div"
                    labelId="earning-select-label"
                    id="earning-select"
                    value={earningFilter}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    onChange={handleEarningChange}
                  >
                    <MenuItem value="" disabled>
                      {translate?.dashboard?.Select}
                    </MenuItem>
                    <MenuItem value="hourly">
                      {translate?.dashboard?.Hourly}
                    </MenuItem>
                    <MenuItem value="weekly">
                      {translate?.dashboard?.Weekly}
                    </MenuItem>
                    <MenuItem value="monthly">
                      {translate?.dashboard?.Monthly}
                    </MenuItem>
                    <MenuItem value="yearly">
                      {translate?.dashboard?.Yearly}
                    </MenuItem>
                  </Select>
                </FormControl>
              </h2>
              <LineChart data={graphRevenueData} />
            </div>
          </Grid>
          {/* <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className="cards dashGraph_item">
              <h2 className="mn_hdng">Popular Plans</h2>
              <Pie
                data={piechartData}
                style={{ height: "300px", width: "300px" }}
              />
            </div>
          </Grid> */}
        </Grid>
      </div>
    </MainContainer>
  );
};

export default Analytics;
